<app-tpl-search [displayFacets]="false">
  <div query>
    <app-communities-recipes-search-query
      [status]="status"
      [domains]="domains | async"
      [markets]="markets"
      [languages]="languages"
      [recipeReasons]="recipeReasons"
      (searchChange)="handleSearchQuery($event)"
    >
    </app-communities-recipes-search-query>
  </div>

  <div result>
    <app-communities-recipes-search-result
      #searchResultComponent
      [domains]="domains | async"
      [markets]="markets"
      [languages]="languages"
      [status]="status"
      [searchResult]="searchResult | async"
      (pageChange)="handleSearchPage($event)"
      (sortChange)="handleSearchSorted($event)"
      [options]="options"
    >
    </app-communities-recipes-search-result>
  </div>
</app-tpl-search>
